import React, { createContext, useState, useEffect } from 'react';
import api from '../api/api';
import history from '../routes/history';
import { toast } from 'react-toastify';

const Context = createContext();

function AuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const parseJwt = (token) => {
      try {
        return JSON.parse(atob(token.split('.')[1]));
      } catch (e) {
        return null;
      }
    };
    const token = JSON.parse(localStorage.getItem('token'));
    if (token) {
      const decodedJwt = parseJwt(token);
      if (decodedJwt.exp * 1000 < Date.now()) {
        setAuthenticated(false);
        localStorage.removeItem('token');
        setLoading(false);
      } else {
        api.defaults.headers.Authorization = `Bearer ${token}`;
        setAuthenticated(true);
        setLoading(false);
      }
    } else {
      setAuthenticated(false);
      localStorage.removeItem('token');
    }
    setLoading(false);
  }, []);

  async function handleLogin(values) {
    setLoading(true);
    await api
      .post('/auth', values)
      .then(({ data }) => {
        console.log(data);
        const { token } = data;
        if (token) {
          api.defaults.headers.Authorization = `Bearer ${token}`;
          setAuthenticated(true);
          localStorage.setItem('token', JSON.stringify(token));
          history.push('/');
          history.go();
        } else {
          toast.error('Usuario ou senha Invalidos ');
          setAuthenticated(false);
          localStorage.removeItem('token');
          setLoading(false);
        }
      })
      .catch((err) => console.log(err))
      .finally(setLoading(false));
  }

  async function handleCheckUser(values) {
    console.log(values);
    await api
      .post('/usuario/consulta', values)
      .then(({ data }) => {
        console.log(data);
        if (data.length !== 0) {
          setAuthenticated(true);
          localStorage.setItem('user', values.email);
          history.push('/resetpassword');
          history.go();
        } else {
          setAuthenticated(false);
          alert('usuario nao encontrado ');
          localStorage.removeItem('token');
          history.push('/login');
          history.go();
        }
      })
      .catch((err) => console.log(err));
  }

  async function handleLogout() {
    setLoading(true);
    setAuthenticated(true);
    localStorage.removeItem('token');
    api.defaults.headers.Authorization = undefined;
    history.push('/login');
    history.go();
  }
  async function verificaToken() {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem('token'));
    const parseJwt = (token) => {
      try {
        return JSON.parse(atob(token.split('.')[1]));
      } catch (e) {
        return null;
      }
    };

    if (token) {
      const decodedJwt = parseJwt(token);
      if (decodedJwt.exp * 1000 < Date.now()) {
        localStorage.removeItem('token');
        setAuthenticated(false);
        history.push('/login');
        history.go();
      } else {
        setAuthenticated(true);
      }
    } else {
      setAuthenticated(false);
      localStorage.removeItem('token');
      history.push('/login');
      history.go();
    }
    setLoading(false);
  }

  return (
    <Context.Provider
      value={{
        authenticated,
        handleLogin,
        setLoading,
        loading,
        handleLogout,
        handleCheckUser,
        verificaToken,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export { Context, AuthProvider };
